export enum DemandTopicStatus {
    Assigned = 'ASSIGNED',
    Unassigned = 'UNASSIGNED',
    NotInterested = 'NOT_INTERESTED',
}
